import { useState } from 'react';
import { DailyOverviewTab } from '@/components/onderaannemers/DailyOverviewTab';
import { OpenPosTab } from '@/components/onderaannemers/OpenPosTab';

type Tab = 'overzicht' | 'inkooporders';

const TABS: Array<{ key: Tab; label: string }> = [
  { key: 'overzicht', label: 'Dagoverzicht' },
  { key: 'inkooporders', label: "Lopende PO's" },
];

export function OnderaannemersView() {
  const [tab, setTab] = useState<Tab>('overzicht');

  return (
    <div className="px-4 lg:px-8 py-6">
      <h1 className="text-xl font-extrabold text-td-navy">Onderaannemers</h1>
      <p className="text-sm text-td-muted mt-0.5">
        {tab === 'overzicht'
          ? "Per onderaannemer, per dag — welke collectoren foto's kregen"
          : 'De huidige lopende inkooporder per onderaannemer'}
      </p>

      <div className="flex gap-1 border-b border-gray-200 mt-4">
        {TABS.map((t) => (
          <button
            key={t.key}
            type="button"
            onClick={() => setTab(t.key)}
            className={`px-4 py-2 text-sm font-semibold -mb-px border-b-2 transition-colors ${
              tab === t.key
                ? 'border-td-blue text-td-blue'
                : 'border-transparent text-td-muted hover:text-td-navy'
            }`}
          >
            {t.label}
          </button>
        ))}
      </div>

      {tab === 'overzicht' ? <DailyOverviewTab /> : <OpenPosTab />}
    </div>
  );
}
